import {
  buildDeliveryHistoryTooltip,
  getDeliveryStatusClass,
  parsePLDate
} from './ProductionCommon';

export { getDeliveryStatusClass, parsePLDate };

export const getNextWednesday = (date) => {
  const d = new Date(date);
  const day = d.getDay(); // 0=Sun, 3=Wed
  const diff = (3 - day + 7) % 7 || 7;
  d.setDate(d.getDate() + diff);
  return d;
};

export const isDelayed = (item) => {
  const today = new Date();
  const availability = item.planned_delivery_date || item.availability;
  const orderDate = parsePLDate(item.document_date);

  // ─── availability = konkretna data ───
  const availabilityDate = parsePLDate(availability);
  if (availabilityDate) {
    return today > availabilityDate;
  }

  // ─── availability = "dostępny" ───
  if (availability && availability.toLowerCase().includes('dost')) {
    if (!orderDate) return false;
    const expected = getNextWednesday(orderDate);
    return today > expected;
  }

  return false;
};

// ─── Helper to build tooltip for delivery date history ───
export const getDeliveryHistoryTooltip = (item) => {
  if (item.change_events?.length > 0) {
    const eventLines = item.change_events.map(event => {
      const quantity = event.quantity !== null && event.quantity !== undefined
        ? `, ilość ${event.quantity}`
        : '';
      return `${event.previous_delivery_date || '—'} → ${event.new_delivery_date || '—'} `
        + `(zmieniono ${event.changed_on || '—'}${quantity})`;
    });
    const warning = item.has_history_gap
      ? `\n\nUwaga: historia zawiera ${item.change_segments_count} niezależne segmenty.`
      : '';
    const tranches = item.tranches?.length > 1
      ? `\n\nPartie początkowe:\n${item.tranches.map(
          tranche => `${tranche.quantity} szt. — ${tranche.initial_availability || 'brak terminu'}`
        ).join('\n')}`
      : '';
    return `Wszystkie zmiany (${item.change_events_count}):\n${eventLines.join('\n')}`
      + `${warning}${tranches}`;
  }
  return buildDeliveryHistoryTooltip(item, item.original_availability, 'Pierwotna data');
};
